import React, { useEffect, useRef, useState } from "react"
import styles from "./ContextMenu.module.scss"
import OutsideClickHandler from "react-outside-click-handler"

// Открытие контекстного меню
export const contextMenuFcn = (
  e: any,
  setOpen: any,
  setContextMenuPos: any,
  disabled?: boolean,
  isRightPos?: boolean, // отобразить всплывающее меню справа
) => {
  if (disabled) return //отключить меню
  e.preventDefault()
  setOpen(true)

  // Смещение если меню вылазит снизу за экран
  const outsideScreen = e.clientY + 104 > window?.innerHeight
  const posOffset = e.clientY + 104 - window?.innerHeight + 10

  // Смещение если меню вылазит снизу за экран
  const outsideScreenX = e.clientX + 208 > window?.innerWidth
  const posOffsetX = e.clientX + 208 - window?.innerWidth + 10

  if (isRightPos) {
    const blockPosition = e.target.getBoundingClientRect()
    const blockWidth = e.target.clientWidth

    const isOutsideX = window?.innerWidth - blockPosition.left < blockWidth * 2

    // console.log('isOutsideX ',isOutsideX)

    setContextMenuPos({
      x: isOutsideX ? blockPosition.right - blockWidth * 2 : blockWidth + blockPosition.left,
      y: blockPosition.top - 1,
    })
  } else {
    setContextMenuPos({
      x: outsideScreenX ? e.clientX - posOffsetX : e.clientX,
      y: outsideScreen ? e.clientY - posOffset : e.clientY,
    })
  }
}

// const [contextMenu, setContextMenu] = useState(false)
// const [contextMenuPos, setContextMenuPos] = useState({x:0, y:0})
// на блоке
// onContextMenu={(e)=>contextMenuFcn(e, setContextMenu, setContextMenuPos)}

interface Props {
  setOpen: any
  children: any
  contextMenuPos: { x: number; y: number }
  onClose?: () => void
  zIndex?: number
  onClick?: any
}

const ContextMenu: React.FC<Props> = ({ onClose, setOpen, children, contextMenuPos, zIndex, onClick }) => {
  const posBoxRef = useRef<any>(null)
  const [positionY, setPositionY] = useState<number>(contextMenuPos.y)

  useEffect(() => {
    setTimeout(() => {
      if (
        posBoxRef?.current?.clientHeight &&
        posBoxRef?.current?.clientHeight + contextMenuPos.y > window?.innerHeight
      ) {
        setPositionY(window?.innerHeight - posBoxRef.current.clientHeight - 12)
      }
    }, 1)
  }, [])

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setOpen(false)
        onClose && onClose()
      }}
    >
      <div
        ref={posBoxRef}
        className={`${styles.context} contextMenu`}
        style={{ top: positionY, left: contextMenuPos.x, zIndex: zIndex }}
        onClick={onClick}
      >
        {children}
      </div>
    </OutsideClickHandler>
  )
}

export default ContextMenu
